/* eslint-disable no-dupe-keys */
// prettier-ignore
module.exports = {
    /* Menu */
    "Dashboard" : "仪表盘",
   
  };
  